'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/11/1.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupBuyingOrderListComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GroupBuyingOrderListComponent, _Component);

  function GroupBuyingOrderListComponent() {
    (0, _classCallCheck3.default)(this, GroupBuyingOrderListComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GroupBuyingOrderListComponent).call(this));
  }

  (0, _createClass3.default)(GroupBuyingOrderListComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./GroupBuyingOrderListComponent.scss');
      var order = this.props.order;

      var path = '/groupbuyingorderdetail/' + order.orderId;
      var evaluateDiv = '';
      if (order.status === '订单完成') {
        var text = '';
        if (order.isEvaluated === '1') {
          text = '已评价';
        } else {
          text = '未评价';
        }
        evaluateDiv = _react2.default.createElement(
          _reactRouter.Link,
          { to: '/orderevaluate/' + order.grounpid, className: styles.evaluate },
          text
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.pagechildren },
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '246px', textIndent: '10px' } },
            '订单号：',
            order.orderId
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '240px' } },
            '时间：',
            order.orderDate
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '219px' } },
            '名称：',
            order.productName
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '155px' } },
            '数量：',
            order.number
          ),
          _react2.default.createElement(
            'div',
            { className: styles.status },
            '状态：',
            order.orderStatus
          ),
          evaluateDiv,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: path, className: styles.childb },
            '订单详情'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return GroupBuyingOrderListComponent;
}(_react.Component), _class.propTypes = {
  order: _react.PropTypes.object
}, _temp);
exports.default = GroupBuyingOrderListComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GroupBuyingOrderListComponent/GroupBuyingOrderListComponent.js
 ** module id = 1352
 ** module chunks = 0
 **/